export default __webpack_public_path__ + "static/media/vision.8b79e12f.svg";